import QTips from './src/main.js';

let instance;

function tips({ duration = 1.5, content = '', type='info', canClick = false }) {
    instance = instance || QTips.newInstance();
    instance.open({
      type: type,
      content: content,
      duration: duration,
      canClick: canClick,
    });
}

function dtips () {
  if (!instance) return;
  instance.close();
}

export default {
  info (options) {
    return tips(options);
  },
  del() {
    return dtips();
  }
}



// WEBPACK FOOTER //
// ./src/components/QTips/index.js